import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import { nextEditRateSort } from '@/lib/deviation-url';
import type { DeviationSort } from '@/services/deviation.service';

const SORT_LABELS: Record<DeviationSort, string> = {
	recent: 'not sorted by edit percentage',
	'editRate.desc': 'sorted high to low',
	'editRate.asc': 'sorted low to high'
};

/** The Deviations log's Edit % column title: a button that cycles high to low, low to high, then newest first. */
export function EditRateSortHeader({ sort, onSort }: { sort: DeviationSort; onSort: (next: DeviationSort) => void }) {
	const Icon = sort === 'editRate.desc' ? ArrowDown : sort === 'editRate.asc' ? ArrowUp : ArrowUpDown;
	return (
		<button
			type='button'
			onClick={() => onSort(nextEditRateSort(sort))}
			aria-label={`Edit %, ${SORT_LABELS[sort]}`}
			title='Share of words changed from the AI draft. Click to sort.'
			className='-mx-1 inline-flex items-center gap-1 rounded px-1 hover:bg-ink/4 focus-visible:bg-ink/4 focus-visible:outline-none'
		>
			Edit %
			<Icon className={sort === 'recent' ? 'size-3.5 text-gray-700' : 'size-3.5 text-ink'} aria-hidden='true' />
		</button>
	);
}
